import * as CONSTANTS from './constants'
import { END_LOADING } from '../screen/constants'

const initialState = {
  currentSync: 1,
  // Informações de progresso detalhadas (opcional)
  progress: {
    attempt: 0,
    maxAttempts: 0,
    entity: null,
    recordsProcessed: 0,
    totalRecords: 0,
    startTime: null,
    // detalhe de "gravando dados" (onProgress de pullChangesEnhanced)
    entityIndex: null,
    totalEntities: null,
    phase: null,
    chunkIndex: null,
    totalChunks: null,
  },
  // PG-063: operação iniciada pelos botões "Sincronizar" (zerada no END_LOADING)
  operation: null,
  // PG-063: aviso que substitui o alert() do warnPull
  notice: null,
  // PG-063: resumo do último pullFarms concluído
  lastPull: null,
}

// P08 FIX: Estados finais que devem resetar o progress
const FINAL_STATES = [
  CONSTANTS.SYNC_STATUS?.ERROR, // 0
  CONSTANTS.SYNC_STATUS?.SUCCESS, // 2
  0, // Fallback para ERROR
  2, // Fallback para SUCCESS
]

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case CONSTANTS.CHANGE_CURRENT_SYNC_VIEW:
      // P08 FIX: Resetar progress quando sync termina (success ou error)
      const shouldResetProgress = FINAL_STATES.includes(action.payload)
      // Nova tentativa de download: não herdar o detalhe de "gravando" da tentativa anterior.
      const startsDownload =
        action.payload === CONSTANTS.SYNC_STATUS.DOWNLOADING_FARM
      return {
        ...state,
        currentSync: action.payload,
        // Resetar progress em estados finais para não mostrar dados stale
        progress: shouldResetProgress
          ? initialState.progress
          : startsDownload
            ? {
                ...state.progress,
                entityIndex: null,
                totalEntities: null,
                recordsProcessed: 0,
                totalRecords: 0,
                phase: null,
                chunkIndex: null,
                totalChunks: null,
              }
            : state.progress,
      }
    case CONSTANTS.UPDATE_SYNC_PROGRESS:
      return {
        ...state,
        progress: {
          ...state.progress,
          ...action.payload,
        },
      }
    case CONSTANTS.SET_SYNC_OPERATION:
      // Começar uma operação apaga o aviso da anterior.
      return {
        ...state,
        operation: action.payload,
        notice: action.payload ? null : state.notice,
      }
    case END_LOADING:
      // O overlay fechou: a operação acabou (evita vazar o modo progresso para outro loading).
      return state.operation ? { ...state, operation: null } : state
    case CONSTANTS.SET_SYNC_NOTICE:
      return { ...state, notice: action.payload }
    case CONSTANTS.SET_PULL_SUMMARY:
      // Pull OK limpa o aviso de erro; só vira "resumo visível" se o usuário iniciou a operação.
      return {
        ...state,
        lastPull: { ...action.payload, userInitiated: state.operation != null },
        notice: null,
      }
    default:
      return state
  }
}
